import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar, } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { LoaderService } from "./../services/loader.service";
import { AuthenticationService } from "../services/authentication.service";
import {SsoService} from "../services/sso.service";
import {addToHistory} from "../../store/history/history.actions";
import {Store} from "@ngrx/store";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  tokenSubject: BehaviorSubject<String> = new BehaviorSubject<String>("");
  public snackbarRef: MatSnackBarRef<SimpleSnackBar> | undefined;

  constructor(
    public loader: LoaderService,
    public router: Router,
    private authService: AuthenticationService,
    public snackbar: MatSnackBar,
    private sso: SsoService,
    private store: Store
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    return next.handle(request).pipe(
      tap(
        (event: any) => {
          if (event instanceof HttpResponse) {
            if (
              !event &&
              !event["body"] &&
              !event["body"]["success"] &&
              !event["body"] &&
              !event["body"]["message"]
            ) {
              // this.loader.hide();

              if (!this.snackbarRef) {
                this.snackbarRef = this.snackbar.open(
                  "messageError",
                  "",
                  {
                    duration: 3000,
                    panelClass: ["primary-background"],
                  }
                );
                this.snackbarRef.afterDismissed().subscribe(() => (this.snackbarRef = undefined));
              }

              this.loader.stopLoader();
            }

          }
        },
        (error) => {

          /** da non togliere */
          console.error(error)
          /** */

          const responseMessage = error["statusText"];

          if (error instanceof HttpErrorResponse) {
            this.loader.stopLoader();
            if (error.status === 401 || error.status === 403) {

              this.store.dispatch(addToHistory({ page: window.location.origin + "/" + error.status }));

              const headersJson = request.headers.keys().reduce((acc, key) => {
                acc[key] = request.headers.get(key);
                return acc;
              }, {} as { [key: string]: string | null });

              localStorage.setItem('Request Headers:', JSON.stringify(headersJson));
              localStorage.setItem("error",JSON.stringify(error));
              this.login();
              return error;
            } else {
              if (responseMessage !== "OK") {
                if (!this.snackbarRef) {
                  this.snackbarRef = this.snackbar.open(
                    "messageError",
                    "",
                    {
                      duration: 3000,
                      panelClass: ["colorErrorMessage"],
                    }
                  );
                  this.snackbarRef.afterDismissed().subscribe(() => (this.snackbarRef = undefined));
                }
              }
              return error;
            }
            return error;
          }

        }
      )
    );
  }

  login() {

    this.sso.isSSO().subscribe(value => {
      const landing = value ? "/sso" : "/login"
      console.log("Navigating from error to: "+landing)
      // Reset di tutti i reducer
      this.store.dispatch({ type: '[Global] Reset State' });
      if(!value) {
        this.router.navigate([landing]);
      }
      else this.router.navigate([landing],{queryParams: { status: 'logout' }});
    }).unsubscribe();
  }
}
